import { Box, styled } from '@mui/material';

export const StudioLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  height: '100vh',
  [theme.breakpoints.down('sm')]: {
    overflow: 'hidden',
  },
}));

export const StudioGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplate: `'info'
                 'formula-editor'
                 'player'
                 'effects-panel'
                `,
  width: '100%',
  gridRowGap: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    gridTemplate: `'info'
                   'player'
                   'effects-panel'
                   'formula-editor'
                  `,
    overflow: 'hidden',
  },
}));

export const StudioGridCell = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 6),
  width: '100%',
  maxWidth: theme.spacing(168),
  justifySelf: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0, 3),
  },
}));

export const InfoCell = styled(Box)(({ theme }) => ({
  gridArea: 'info',
  display: 'flex',
  justifyContent: 'center',
  borderColor: theme.palette.grey[700],
  borderTopStyle: 'solid',
  borderBottomStyle: 'solid',
}));

export const FormulaEditorCell = styled(StudioGridCell)(({ theme }) => ({
  gridArea: 'formula-editor',
  marginInline: 'auto',
  [theme.breakpoints.down('sm')]: {
    borderTop: '1px solid',
    borderColor: theme.palette.grey[700],
    padding: theme.spacing(0),
  },
}));

export const PlayerCell = styled(StudioGridCell)({
  gridArea: 'player',
});

export const EffectsPanelCell = styled(StudioGridCell)(({ theme }) => ({
  gridArea: 'effects-panel',
  [theme.breakpoints.down('sm')]: {
    overflow: 'scroll',
  },
}));
